import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import { useErrorStore } from 'store/error';

import { dialogTextCss, actionButtonCss } from './styles';

const GlobalError = () => {
  const { showError, setCloseError } = useErrorStore((state) => state);

  const handleClose = () => {
    setCloseError();
    window.location.reload();
  };

  return (
    <Dialog open={showError} onClose={setCloseError} fullWidth maxWidth='xs'>
      <DialogContent>
        <DialogContentText className={dialogTextCss}>
          Maaf ya, ada sedikit masalah. Silakan klik "Coba Lagi" untuk tampilkan
          halaman ini, ya!
        </DialogContentText>
        <Button
          variant='contained'
          fullWidth
          onClick={handleClose}
          className={actionButtonCss}
        >
          Coba Lagi
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default GlobalError;
